import React, { useContext, useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const LoggedRoute = ({ component: Component, ...rest }) => {
  const { setUserFromStorage } = useContext(AuthContext);

  const history = useHistory();

  /**
   * TODO: This needs to be called also on unauthenticated routes, right now we see the user only on authenticated routes
   * Also, if a valid token is present in localstorage, we do not need to login again.
   */
  useEffect(() => {
    //Try to get the user from the local storage, if the user is present it can be still logged
    if (localStorage.getItem("user")) {
      setUserFromStorage();
    } else {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
      }}
    />
  );
};

export default LoggedRoute;
